export default {
  input: {
    language: {
      label: "Weergave taal",
      text: "De taal waarin je Stickyweb wilt gebruiken"
    },
    name: "Naam",
    email: {
      label: "E-mail",
      text: "Bij het aanpassen van het e-mailadres wordt je automatisch uitgelogd.",
    }
  },
  success: {
    saved: "Nieuwe gegevens opgeslagen",
  },
  buttons: {
    save: "Opslaan",
  },
}
